$(function () {
    // 弹窗展示
    $('#{{ section.id }}ExplanationDialog').on('click', function () {
      $('#{{ section.id }}ExplanationModal').fadeIn(150);
      disableScroll();
    });
    $('#{{ section.id }}ExplanationModalClose').on('click', function () {
      $('#{{ section.id }}ExplanationModal').fadeOut(150);
      enableScroll();
    });
    // 存储原始滚动位置
    let scrollPosition = 0;
    // 禁止滚动函数
    function disableScroll() {
      scrollPosition = $(window).scrollTop();
      $('body').css({
        overflow: 'hidden',
        position: 'fixed',
        top: -scrollPosition + 'px',
        width: '100%',
      });
      $('.header-wrapper').hide();
    }

    // 恢复滚动函数
    function enableScroll() {
        $('.header-wrapper').show();
      $('body').css({
        overflow: '',
        position: '',
        top: '',
        width: '',
      });
      $(window).scrollTop(scrollPosition);
    }

    // 处理浏览器窗口大小变化
    $(window).resize(function () {
      if ($('body').css('overflow') === 'hidden') {
        $('body').css('top', -$(window).scrollTop() + 'px');
      }
    });
  });